import Vue from 'vue';
import VueScrollTo from 'vue-scrollto';
import VueI18n from 'vue-i18n';
import VueRouter from 'vue-router';
import {filters} from '@common/filters';
import Validators from '@common/validators.js';
import VueMeta from 'vue-meta';
import router from '@router';
import App from './App.vue';
import store from './store';
import Toastr from 'vue-toastr';
import Cookies from 'js-cookie';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import vClickOutside from 'v-click-outside';
import VueHead from 'vue-head';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import VModal from 'vue-js-modal';
import VueDraggable from 'vue-draggable';
import VueQuillEditor from 'vue-quill-editor';
import VueCarousel from '@chenfengyuan/vue-carousel';

import 'quill/dist/quill.core.css'; // import styles
import 'quill/dist/quill.snow.css'; // for snow theme
import 'quill/dist/quill.bubble.css'; // for bubble theme
import 'jquery/src/jquery';
import 'bootstrap';
import '@assets/js/mdb.min';

import AdminHeader from '@components/layout/admin/Header';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faMobileAlt, faAngleDown, faAngleLeft, faAngleRight, faTrashAlt, faComments, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { faClock, faEnvelope } from '@fortawesome/free-regular-svg-icons';

library.add(faClock, faEnvelope, faMobileAlt, faAngleDown, faAngleLeft, faAngleRight, faTrashAlt, faComments, faFilePdf);

Vue.component('fa-icon', FontAwesomeIcon);

// mdb fix
import bsCustomFileInput from 'bs-custom-file-input';
global.bsCustomFileInput = bsCustomFileInput;

Validators.init();
Vue.use(VueMeta);
Vue.use(VueQuillEditor, /* { default global options } */);
Vue.use(VueDraggable);
Vue.use(VueScrollTo);
Vue.use(VModal);
Vue.use(DatePicker);
Vue.use(VueHead);
Vue.use(VueI18n);
Vue.use(VueRouter);
Vue.use(Toastr, {
    defaultTimeout: 5000,
    defaultPosition: 'toast-top-center',
    defaultCloseOnHover: false,
    defaultPreventDuplicates: true,
    defaultProgressBar: false
});

let locale = Cookies.get('locale');
if (!locale) {
    locale = process.env.VUE_APP_LOCALE;
}
const i18n = new VueI18n({
    locale,
    messages: {},
    silentTranslationWarn: true
});
Vue.component('vue-carousel', VueCarousel);
Vue.component('AdminHeader', AdminHeader);
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

const requireComponent = require.context('./common/components/global', false, /.*\.(vue)$/);
requireComponent.keys().forEach((fileName) => {
    const Component = requireComponent(fileName).default;
    if (Component.name) {
        Vue.component(Component.name, Component);
    }
});

Vue.directive('click-outside', vClickOutside.directive);

export const vm = new Vue({
    el: '#app',
    i18n,
    router,
    filters,
    store,
    render: h => h(App)
});
export const eventBus = new Vue();
